<template>
  <DxPopup @hidden="onHidden" :visible="reInspPop" :show-close-button="true" :show-title="true" :title="'Re-Inspecton requestion Control'" height="430px" width="900px" container=".v-application">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="'Re-Inspection Requestion Apply'"
                         :useBtnList="useBtnList"
                         @btnClose="btnClose()" @btnApplyRequestPop="btnApplyRequestPop()"
        >
          <template v-slot:body>
            <v-row>
              <v-col cols="12" class="pa-0">
                <i-card-top
                    class="d-md-flex"
                    outlined
                >
                  <template v-slot:body>
                    <v-row no-gutters class="pa-0 pl-1">
                      <v-col cols="12">

                        <v-row dense class="rowGubun">
                          <v-col cols="2 of 10" align="right" class="pa-2" style="border-right: 1px solid #bcc0c9;">
                            <span class="subTitle">Supplier name : </span>
                          </v-col>
                          <v-col cols="5 of 10" >
                            <v-select
                                v-model="supName"
                                :items="supNameList"
                                item-value="supName"
                                return-object
                                single-line
                                outlined
                                dense
                                disabled
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row dense class="mt-0 rowGubun">
                          <v-col cols="2 of 10" align="right" class="pa-2" style="border-right: 1px solid #bcc0c9;">
                            <span class="subTitle">Ship No : </span>
                          </v-col>
                          <v-col cols="2 of 10">
                            <v-select
                                v-model="shipNo"
                                :items="shipNoList"
                                item-value="shipNo"
                                return-object
                                single-line
                                outlined
                                dense
                                disabled
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row dense class="mt-0 rowGubun">
                          <v-col cols="2 of 10" align="right" class="pa-2" style="border-right: 1px solid #bcc0c9;">
                            <span class="subTitle">Attend Insp. : </span>
                          </v-col>
                          <v-col cols="2 of 10" class="pt-1">
                            <v-checkbox
                                v-model="wqm"
                                label="QM"
                                disabled
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="2 of 10" class="pt-1">
                            <v-checkbox
                                v-model="wow"
                                label="Owner"
                                disabled
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="2 of 10" class="pt-1">
                            <v-checkbox
                                v-model="wcl"
                                label="Class"
                                disabled
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="2 of 10" class="pt-1">
                            <v-checkbox
                                v-model="wmk"
                                label="Maker"
                                disabled
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                        <v-row dense class="mt-0 rowGubun">
                          <v-col cols="2 of 10" align="right" class="pa-2" style="border-right: 1px solid #bcc0c9;">
                            <span class="subTitle">Insp. date : </span>
                          </v-col>
                          <v-col cols="3 of 10">
                            <DxDateBox
                                :value="stDate"
                                height="30px"
                                display-format="yyyy-MM-dd"
                                :acceptCustomValue="false"
                                @value-changed="e => {stDate = e.value}"
                            />
                          </v-col>
                          <v-col cols="2 of 10" align="right" class="pa-2" >
                            <span class="subTitle">Insp. time </span>
                          </v-col>
                          <v-col cols="3 of 10">
                            <v-select
                                v-model="insTime"
                                :items="insTimeList"
                                item-value="codeName"
                                item-text="timeNm"
                                return-object
                                single-line
                                outlined
                                dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row dense class="mt-0 rowGubun">
                          <v-col cols="2 of 10" align="right" class="pa-2" style="border-right: 1px solid #bcc0c9;">
                            <span class="subTitle">Insp.Place : </span>
                          </v-col>
                          <v-col cols="3 of 10">
                            <v-select
                                v-model="inspLoc"
                                :items="inspLocList"
                                item-value="code"
                                item-text="codeName"
                                return-object
                                single-line
                                outlined
                                dense
                                disabled
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row dense class="mt-0 rowGubun">
                          <v-col cols="2 of 10" align="right" class="pa-2" style="border-right: 1px solid #bcc0c9;">
                            <span class="subTitle">Item Description : </span>
                          </v-col>
                          <v-col cols="3 of 10">
                            <v-text-field
                                v-model="itemDesc"
                                dense
                                outlined
                                hide-details="auto"
                                readonly
                            />
                          </v-col>
                        </v-row>
                        <v-row dense class="mt-0 rowGubun">
                          <v-col cols="2 of 10" align="right" class="pa-2" style="border-right: 1px solid #bcc0c9;">
                            <span class="subTitle">Inspection Kind : </span>
                          </v-col>
                          <v-col cols="3 of 10">
                            <v-text-field
                                v-model="kindNm"
                                dense
                                outlined
                                hide-details="auto"
                                readonly
                            />
                          </v-col>
                        </v-row>


                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
// import { DxDataGrid, DxEditing, DxColumn , DxPager ,DxLookup } from 'devextreme-vue/data-grid'
import DxDateBox from 'devextreme-vue/date-box'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { v80o1020Reinsp } from '@/api/view/hip/8/v80o1020Popup.js'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import notify from 'devextreme/ui/notify' // message
import dayjs from 'dayjs'

export default {
  name: 'v80o1020ReInspPop',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxPopup,
    ICardVertical,
    iCardTop,
    DxDateBox
  },
  props: {
    reInspPop: {
      type: Boolean,
      default() { return false }
    },
    popupData: {
      type: Array,
      default() { return }
    },
    insTimeListPop: {
      type: Array,
      default() { return }
    },
    shipNoListPop: {
      type: Array,
      default() { return }
    },
    supNameListPop: {
      type: Array,
      default() { return }
    },

  },
  data() {
    return {
      useBtnList: ['btnApplyRequestPop','btnClose'],

      supName: '',
      shipNo: '',
      insTime: '',

      checkbox: true,
      stDate: '',

      shipNoList: this.shipNoListPop,
      supNameList: this.supNameListPop,
      insTimeList: [],

      wqm: false,
      wow: false,
      wcl: false,
      wmk: false,

      inspLoc: '',
      inspLocList: [],

      itemDesc: '',
      kindNm: '',
    }
  },
  watch: {
    'reInspPop': {
      handler(value, oldValue) {
        if(value) {
          let toDay = new Date
          toDay.setDate(toDay.getDate() + 1);
          this.stDate = toDay
          this.supName = this.popupData[0].supName
          this.shipNo = this.popupData[0].shipNo
          this.inspLoc = this.popupData[0].insLoc
          this.itemDesc = this.popupData[0].item
          this.kindNm = this.popupData[0].kindNm
          this.wqm = this.popupData[0].wqm === 'Y' ? true : false
          this.wow = this.popupData[0].wow === 'Y' ? true : false
          this.wcl = this.popupData[0].wcl === 'Y' ? true : false
          this.wmk = this.popupData[0].wmk === 'Y' ? true : false

          this.getList()
        }
      },
      immediate: true
    }
  },
  computed: {

  },
  // mounted(){
  //   let toDay = new Date
  //   toDay.setDate(toDay.getDate() + 1);
  //   this.stDate = toDay

  //   // this.supName = this.popupData[0].supName
  //   // this.shipNo = this.popupData[0].shipNo
  //   // this.inspLoc = this.popupData[0].insLoc
  //   // this.itemDesc = this.popupData[0].item
  //   // this.kindNm = this.popupData[0].kindNm
  //   // this.wqm = this.popupData[0].wqm === 'Y' ? true : false
  //   // this.wow = this.popupData[0].wow === 'Y' ? true : false
  //   // this.wcl = this.popupData[0].wcl === 'Y' ? true : false
  //   // this.wmk = this.popupData[0].wmk === 'Y' ? true : false

  //   // this.getList()
  //   // this.doSearchMain()
  // },
  methods: {
    onHidden(e) {
      let param = {
        stDate: this.stDate,
        inspDiv: this.popupData[0].inspDiv,
        supName: this.supName,
        shipNo: this.popupData[0].shipNo,
        // qmPart: this.popupData[0].qmPart,
        // attendInsp: this.popupData[0].attendInsp,
        // kindCd: this.popupData[0].kindCd,
        // insRes: '',

      }
      this.$emit('reInsp',  param)
      this.$emit('update:reInspPop', false)
    },
    onHidden2(e) {
      let param = {
        stDate: this.stDate,
        inspDiv: this.popupData[0].inspDiv,
        supName: this.supName,
        shipNo: this.popupData[0].shipNo,
        // qmPart: this.popupData[0].qmPart,
        // attendInsp: this.popupData[0].attendInsp,
        // kindCd: this.popupData[0].kindCd,
        // insRes: '',
      }
      this.$emit('reInsp',  param)
    },
    async getList(){
      let param = {
        code: '',
        codegr: '',
        prtCode: 'INSP_LOC2',
        userFlag: 'Y'
      }
      await getCmChildCode(param).then(res => {
        res.list.forEach(e => {

          this.inspLocList.push(e)

          // let filter = []
          // if(e.codeName != 'All'){
          //   filter = e.codeName.split(': ')
          //   e.codeName = filter[1]
          // }else {
          //   e.codeName = ''
          // }

        });
        this.inspLocList = res.list
      })

      let param2 = {
        makerCd: this.$store.state.user.makerCd,
        code: '',
        codegr: '',
        prtCode: 'TIME_INSP',
        userFlag: 'Y',
      }
      getCmChildCode(param2).then(res => {
        res.list.forEach(e => {
          if(e.codeName != null){
            e.timeNm = e.codeName.substring(0,2) + ':' +  e.codeName.substring(2)
          } else {
            e.timeNm = ''
          }
        });
        this.insTimeList = res.list
      })
    },
    btnApplyRequestPop(){
      let minDate = new Date
      // minDate.setDate(minDate.getDate() + 1);
      minDate = dayjs(minDate).format('YYYY-MM-DD')

      if(!this.stDate){
        this.vToastify(this.$t('Select the Inspection Date to Re-inspection apply.'), 'warn')
        return
      }
      if(!this.insTime){
        this.vToastify(this.$t('Select the Inspection Time to Re-inspection apply.'), 'warn')
        return
      }
      if(dayjs(this.stDate).format('YYYY-MM-DD') < minDate){
        this.vToastify(this.$t('You cannot Re-inspection request the inspection of this day. You select Re-Inspection Date over today please!'), 'warn')
        return
      }
      let param = [{
        inspAct: this.popupData[0].inspAct,
        insDate: this.popupData[0].insDate,
        newInsDate: dayjs(this.stDate).format('YYYY-MM-DD'),
        insTime: this.insTime.codeName,
        shipNo: this.popupData[0].shipNo,
        makerCd: this.popupData[0].makerCd,
        userId: this.$store.state.user.userId
      }]

      this.vToastifyPrompt(
          this.$t('Are you want to want re-arrangement inspection request?'),
          'info',
          current => {
            this.openLoading('searching')
            v80o1020Reinsp(param).then(res => {
              if(res.body == 'Y'){
                notify(this.$t('The Re-Inspection request Apply is completed.'), 'success', 3000)
              }else {
                this.vToastify(this.$t('An error has occured while Re-Inspection Apply...'), 'warn')
              }
              this.onHidden2()
            })
                .catch(error => {
                  this.endLoading()
                })
                .finally(() => {
                })
          },
          null,
          true
      )

    },
    btnClose(){
      this.onHidden()
    },
    cellPrepared(e){
      if(e.rowType === 'data'){
        e.cellElement.style.padding = '0px'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.subTitle {
  font-weight: bold;
}
.rowGubun {
  border-bottom: 1px solid #bcc0c9;
  color: black;
}
</style>